import React from 'react';
import { AAutoCompleteDropdownIndicator } from './AAutoComplete';
import APopover from '../a-popover';
import AInput from '../formFeilds/customInput/AInput';
// import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { MdArrowDropDown } from "react-icons/md";
import { InputLabelStyle } from './ASelect';
import { InputLabel } from "@mui/material";


const ASearchableSelect = ({
  className,
  label = "",
  labelStyle = { color: "#262626" },
  userSearchInput,
  setUserSearchInput,
  handleOnUserInput,
  onKeyDownHandler,
  selectedOption,
  setSelectedOption,
  isMulti = false,
  searchInputHandler = () => { },
  items = [],
  loading = false,

  // Search By Selector
  searchByOptions = [],
  selectedSearchInputOption,
  setSelectedSearchInputOption,

  // UI & Styling
  placeholder = "Search...",
  noResultsText = "No options available",
  inputStyle = { width: "100%" },
  inputSearchOptionStyles = {
    position: "absolute",
    bottom: "0",
    margin: "auto 0",
    background: "#FFF6E3",
    color: "#A17217",
    border: "none",
  },
  customSearchIconStyle = { left: "5px" },
  rightCustomIconStyles = {
    fontSize: "12px",
    position: "absolute",
    bottom: "7px",
    right: "90px",
    margin: "auto",
  },
}) => {

  const handleSearch = () => {
    searchInputHandler();
  };

  const handleSelect = (option, closeForm) => {
    if (isMulti) {
      const currentSelected = Array.isArray(selectedOption) ? selectedOption : [];
      const isAlreadySelected = currentSelected.some(item => item.value === option.value);

      const newSelected = isAlreadySelected
        ? currentSelected.filter(item => item.value !== option.value)
        : [...currentSelected, option];

      setSelectedOption(newSelected);
    } else {
      // Single Select
      setSelectedOption(option);
      setUserSearchInput("");
      closeForm();
    }
  };

  const isItemSelected = (option) => {
    if (isMulti) {
      const currentSelected = Array.isArray(selectedOption) ? selectedOption : [];
      return currentSelected.some(item => item.value === option.value);
    }
    // Single select
    return selectedOption?.value === option.value;
  };

  // Display value in trigger button
  const displayValue = () => {
    if (isMulti) {
      const count = Array.isArray(selectedOption) ? selectedOption.length : 0;
      return count > 0 ? `${count} vendors selected` : placeholder;
    }
    return selectedOption ? (selectedOption.value) : placeholder;
  };

  return (
    <div className={className}>
      {label && (
        <InputLabel sx={{ ...InputLabelStyle, ...labelStyle }}>
          {label}
        </InputLabel>
      )}
      <APopover
        buttonComponent={(onClick) => (
          <div
            onClick={onClick}
            style={{
              border: "1px solid #CFD3D4",
              borderRadius: "8px",
              padding: "3px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              backgroundColor: "#fff",
              minHeight: "32px",
              width: "220px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ color: selectedOption ? "#000" : "hsl(0, 0%, 50%)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px" }}>
                {displayValue()}
              </span>
            </div>
            <MdArrowDropDown size={22} />
          </div>
        )}
        menuComponent={(closeForm) => (
          <div style={{ minWidth: "320px", padding: "12px" }}>
            {/* Search + By Selector */}
            <div style={{ padding: "12px" }}>
              <AInput
                placeholder={placeholder}
                value={userSearchInput}
                handler={handleOnUserInput}
                onKeyDown={onKeyDownHandler}
                searchIconClickHandler={handleSearch}
                crossIcon={false}
                searchIcon={true}
                style={inputStyle}
                customSearchIconStyle={customSearchIconStyle}
                rightCustomIconStyles={rightCustomIconStyles}
                rightCustomIcon={
                  searchByOptions.length > 0 && (
                    <select
                      value={selectedSearchInputOption}
                      onChange={(e) => setSelectedSearchInputOption(e.target.value)}
                      style={inputSearchOptionStyles}
                    >
                      {searchByOptions.map(({ key, value }) => (
                        <option key={key} value={key}>
                          {value}
                        </option>
                      ))}
                    </select>
                  )
                }
              />
            </div>

            {/* Options List */}
            <div style={{ maxHeight: "280px", overflowY: "auto" }}>
              {loading && <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>Searching...</div>}

              {!loading && items.length === 0 && (
                <div style={{ padding: "20px 16px", color: "#999", textAlign: "center" }}>
                  {noResultsText}
                </div>
              )}

              {items.map((option, index) => {
                const uniqueKey = `${option.value || 'item'}-${index}`;

                return (
                  <div
                    key={uniqueKey}
                    onClick={() => handleSelect(option, closeForm)}
                    style={{
                      padding: "12px 16px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      backgroundColor: isItemSelected(option) ? "#F0F8FF" : "transparent",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = isItemSelected(option) ? "#F0F8FF" : "transparent")
                    }
                  >
                    <input
                      type="checkbox"
                      checked={isItemSelected(option)}
                      readOnly
                      style={{
                        cursor: "pointer",
                        width: "18px",
                        height: "18px",
                        accentColor: "#007BFF"
                      }}
                    />
                    <span style={{ flex: 1, fontSize: "14px" }}>{option.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default ASearchableSelect;